<template>
  <b-row>
    <b-col cols="6">
      <b-card no-body header="Aviso de Férias">
        <b-card-body>
          <b-alert
            v-if="showVacationSessionBanner"
            show
            variant="warning"
            class="mb-3"
          >
            Você está com aviso de férias ativo de
            <strong>{{ formatVacationDate(vacation.begin) }}</strong>
            até
            <strong>{{ formatVacationDate(vacation.end) }}</strong>
            <span v-if="designatedAdminName">
              . Administrador nomeado:
              <strong>{{ designatedAdminName }}</strong>
            </span>
          </b-alert>
          <b-row>
            <b-col>
              <b-form-group label="Início">
                <b-form-datepicker
                  v-bind="locale.pt"
                  v-model="vacation.begin"
                  locale="pt"
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  }"
                  value-as-date
                  aria-describedby="invalidVacationBegin"
                  name="vacationBegin"
                  :min="`${minDate.getFullYear()}-${(minDate.getMonth() + 1)
                    .toString()
                    .padStart(2, '0')}-${minDate
                    .getDate()
                    .toString()
                    .padStart(2, '0')}`"
                  :state="validateBegin()"
                />
                <b-form-invalid-feedback id="invalidVacationBegin">
                  {{
                    !vacation.begin
                      ? "O campo Início é obrigatório!"
                      : "O campo Início deve ser menor que o campo Fim!"
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Fim">
                <b-form-datepicker
                  v-bind="locale.pt"
                  v-model="vacation.end"
                  locale="pt"
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  }"
                  value-as-date
                  aria-describedby="invalidVacationEnd"
                  name="vacationEnd"
                  :min="`${minDate.getFullYear()}-${(minDate.getMonth() + 1)
                    .toString()
                    .padStart(2, '0')}-${minDate
                    .getDate()
                    .toString()
                    .padStart(2, '0')}`"
                  :state="validateEnd()"
                />
                <b-form-invalid-feedback id="invalidVacationEnd">
                  {{ validateEnd() }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group
                label="Administrador nomeado"
                description="O usuário nomeado poderá ver as novas denúncias que chegarem nesse período"
              >
                <b-select
                  v-model="vacation.designatedAdmin"
                  :options="userOpts"
                ></b-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-footer>
          <b-button
            :disabled="!(validateBegin() && validateEnd())"
            variant="primary"
            @click="save()"
            >Salvar</b-button
          >
          <b-button
            class="ml-2"
            :disabled="!vacationConfigured"
            @click="reset()"
            >Cancelar Férias</b-button
          >
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { getCompanyUsers } from "../../api/company";
import { mapGetters } from "vuex";
import { getVacation, setVacation, cancelVacation } from "../../api/user";

export default {
  name: "SettingsView",
  data() {
    return {
      locale: {
        pt: {
          labelPrevDecade: "Década anterior",
          labelPrevYear: "Ano anterior",
          labelPrevMonth: "Mês anterior",
          labelCurrentMonth: "Mês atual",
          labelNextMonth: "Próximo mês",
          labelNextYear: "Próximo ano",
          labelNextDecade: "Próxima década",
          labelTodayButton: "Hoje",
          labelSelected: "Data selecionada",
          labelNoDateSelected: "Selecione uma data",
          labelCalendar: "Calendário",
          labelNav: "Navegação do calendário",
          labelHelp: "Use as setas para navegar",
        },
      },
      vacation: {
        begin: null,
        end: null,
        designatedAdmin: null,
      },
      vacationConfigured: false,
      companyUsers: [],
      userOpts: [],
      loaded: false,
      showVacationSessionBanner: false,
    };
  },
  computed: {
    ...mapGetters(["profile"]),
    minDate() {
      return new Date();
    },
    designatedAdminName() {
      if (!this.vacation.designatedAdmin || !this.companyUsers.length) {
        return "";
      }

      const designated = this.companyUsers.find(
        (user) => user._id === this.vacation.designatedAdmin
      );

      if (!designated) {
        return "";
      }

      return `${designated.name} ${designated.surname}`.trim();
    },
  },
  async created() {
    this.loaded = false;
    await this.loadVacation();
    await this.loadUserOpts();
    this.evaluateVacationSessionNotice();
    this.loaded = true;
  },
  methods: {
    formatVacationDate(value) {
      if (!value) {
        return "";
      }

      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) {
        return "";
      }

      return date.toLocaleDateString("pt-BR");
    },
    isVacationActive() {
      if (!this.vacation.begin || !this.vacation.end) {
        return false;
      }

      const begin = new Date(this.vacation.begin);
      const end = new Date(this.vacation.end);

      if (Number.isNaN(begin.getTime()) || Number.isNaN(end.getTime())) {
        return false;
      }

      const now = new Date();
      return begin <= now && now <= end;
    },
    getVacationSessionNoticeKey() {
      if (!this.profile || !this.profile._id || !this.vacation.end) {
        return "";
      }

      const end = new Date(this.vacation.end);
      const begin = new Date(this.vacation.begin);

      if (Number.isNaN(end.getTime()) || Number.isNaN(begin.getTime())) {
        return "";
      }

      return `vacation-notice:${
        this.profile._id
      }:${begin.toISOString()}:${end.toISOString()}`;
    },
    evaluateVacationSessionNotice() {
      this.showVacationSessionBanner = false;

      if (!this.isVacationActive()) {
        return;
      }

      const key = this.getVacationSessionNoticeKey();
      if (!key) {
        return;
      }

      try {
        const alreadyShown = window.sessionStorage.getItem(key);
        if (alreadyShown) {
          return;
        }
        this.showVacationSessionBanner = true;
        window.sessionStorage.setItem(key, "1");
      } catch (_) {
        this.showVacationSessionBanner = true;
      }
    },
    validateBegin() {
      if (this.vacation.begin) {
        if (this.vacation.end) {
          if (this.vacation.begin.getTime() > this.vacation.end.getTime()) {
            return false;
          }
        }
        return true;
      }
    },
    validateEnd() {
      if (this.vacation.end) {
        return true;
      }
    },
    async loadVacation() {
      const response = await getVacation();
      const { data } = response;
      if (data.begin) {
        this.vacation.begin = new Date(data.begin);
        this.vacation.end = new Date(data.end);
        this.vacation.designatedAdmin = data.designatedAdmin;
        this.vacationConfigured = true;
      }
    },
    async loadUserOpts() {
      const response = await getCompanyUsers(this.profile.company);
      this.companyUsers = response.data;
      const userOpts = [];

      const myId = this.profile._id;
      for (const user of this.companyUsers) {
        if (user._id === myId) {
          continue;
        }
        userOpts.push({
          value: user._id,
          text: `${user.name} ${user.surname}`,
        });
      }
      userOpts.unshift({ value: null, text: "" });
      this.userOpts = userOpts;
    },
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    async reset() {
      const currentNoticeKey = this.getVacationSessionNoticeKey();
      this.vacation = {
        begin: null,
        end: null,
        designatedAdmin: null,
      };
      this.showVacationSessionBanner = false;
      if (currentNoticeKey) {
        try {
          window.sessionStorage.removeItem(currentNoticeKey);
        } catch (_) {
          // Ignora indisponibilidade de sessionStorage
        }
      }
      try {
        await cancelVacation();
        this.$bvToast.toast("Férias canceladas com sucesso!", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        });
      } catch (error) {
        if (error.response.status >= 400 && error.response.status < 500) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
      }
      this.vacationConfigured = false;
    },

    async save() {
      try {
        await setVacation(this.vacation);
        this.evaluateVacationSessionNotice();
        this.$bvToast.toast("Aviso de Férias configuradas com sucesso!", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        });
      } catch (error) {
        if (error.response.status >= 400 && error.response.status < 500) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
      }
    },
  },
};
</script>
